import React, { useState } from 'react';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import TextField from '@mui/material/TextField';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

const CURRENCIES = ['EUR', 'USD'];

interface Props {
  value: string;
  onChange: (value: string) => void;
  sx?: object;
}

const normalizeCurrency = (value: string) =>
  value.replace(/[^A-Za-z]/g, '').toUpperCase().slice(0, 3);

/** Freitext mit Schnellauswahl für Euro und US-Dollar. */
const WaehrungField: React.FC<Props> = ({ value, onChange, sx }) => {
  const [anchor, setAnchor] = useState<HTMLElement | null>(null);

  const choose = (currency: string) => {
    onChange(currency);
    setAnchor(null);
  };

  return (
    <>
      <TextField
        label="Währung"
        value={value}
        onChange={(event) => onChange(normalizeCurrency(event.target.value))}
        inputProps={{ maxLength: 3 }}
        sx={{ width: 148, minWidth: 148, flexShrink: 0, ...sx }}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                size="small"
                edge="end"
                aria-label="Währung auswählen"
                onClick={(event) => setAnchor(event.currentTarget)}
              >
                <ArrowDropDownIcon />
              </IconButton>
            </InputAdornment>
          ),
        }}
      />
      <Menu
        anchorEl={anchor}
        open={Boolean(anchor)}
        onClose={() => setAnchor(null)}
      >
        {CURRENCIES.map((currency) => (
          <MenuItem
            key={currency}
            selected={currency === value}
            onClick={() => choose(currency)}
          >
            {currency}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default WaehrungField;
